// extracted by mini-css-extract-plugin
export var chevronIcon = "_e4-2";
export var teamName = "_e4-1";
export var teamSwitcherButton = "_e4-0";